export const RETRIES = 4
export const RETRY_WAIT_MILLI_SECONDS = 1000
export const CODES_TO_RETRY = [502, 503, 504, 429]
